<script>

	/* image extends intro {
		...
		image: Image
		fit: string (crop|fit)
	} */

	export let image;
	export let fit;

</script>

<figure class="container {fit}">
	<img src="{image.src}" srcset="{image.srcset}" loading="lazy" alt="Johannes Ludwig" />
	{#if image.caption}
		<figcaption>{image.caption}</figcaption>
	{/if}
</figure>

<style>

	figure {
		position: relative;
	}
	
	figcaption {
		position: absolute;
		left: 0;
		bottom: 0;
		padding: 1em;
	}

	img {
		width: 100%;
		height: auto;
	}

	.crop,
	.fit {
		height: var( --introHeight );
	}
	
	.crop img,
	.fit img {
		width: 100%;
		height: 100%;
		object-position: center;
	}

	.crop img {
		object-fit: cover;
	}

	.fit img {
		object-fit: contain;
	}

</style>